import { Box, Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useToast } from "../../../Hooks/useToast";
import { usePostValidateCodeMutation, usePostVerifyPhoneNumberMutation } from "../../../Redux/api/verificationApi";
import { useAppDispatch, useAppSelector } from "../../../Redux/store";
import { KaziButton } from "../../../Shared Components/Kazi/KaziButton";
import { setProgress, setSubtitle } from "../Slices/accountCreationSlice";
import { VerificationConsentModal } from "./VerificationConsentModal";

interface CodeVerificationProps {}
export const CodeVerification = (props: CodeVerificationProps) =>{
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const { showToast } = useToast();
    const [ verifyPhone, {isLoading: verificationLoading} ] = usePostVerifyPhoneNumberMutation();
    const [ validateCode, { isLoading: validationLoading} ] = usePostValidateCodeMutation();
    const phoneNumber = useAppSelector( state => state.AccountCreation.PhoneNumber);
    /* ******************** Variables ******************** */
    const [code, setCode] = useState<string | undefined>(undefined);
    const [modalOpen, setModalOpen] = useState(false);
    /* ******************** Functions ******************** */
    const handleBack = () => {
        dispatch(setProgress(80))
    }
    const handleVerify = () => {
        verifyPhone({
            phoneNumber: phoneNumber!,
            consentSource: "Sign-up flow"
        })
        .unwrap()
        .then(() => {
            dispatch(setSubtitle('A text message has been sent to your phone, verify the code here'))
            setModalOpen(false);
        })
        .catch((err) => {
            console.error('Error occured while sending OTP: ', err);
            showToast({
                text: 'Unable to send verification code',
                variant: 'error'
            })
        })
    }
    const handleValidate = () => {
        validateCode({
            code: code!,
            phoneNumber: phoneNumber!
        })
        .unwrap()
        .then( res => {
            if (res.valid){
                dispatch(setProgress(95))
            } else {
                showToast({
                    text: 'Invalid Code',
                    variant: 'error'
                })
            }
        }).catch( err => {
            console.error(err);
            showToast({
                text: 'Unable to validate code',
                variant: 'error'
            })
        })
    }    
    /* ******************** Effects ******************** */
    useEffect(() => {
        dispatch(setSubtitle('SMS Verification')) 
        setModalOpen(true);
    }, [])
    /* ******************** JSX ******************** */
    return (
        <>
            <TextField
                placeholder="Code"
                sx={{
                    marginBottom: "30px",
                    width: "300px"
                }}
                value={code ?? ""}
                onChange={(event) => setCode(event.target.value)}
            />
            <Box display={"flex"} flexDirection={"row"} justifyContent={"center"} alignItems={"center"} gap={2}>
                <Button variant="contained" size="large" color="secondary" onClick={handleBack}>Back</Button>
                <KaziButton 
                    variant="contained" 
                    disabled={code === undefined} 
                    size="large" 
                    onClick={handleValidate}
                    text="Verify"
                    loading={{
                        isLoading: validationLoading,
                        loadingText: "Validating code..."
                    }}
                />
            </Box>
            <VerificationConsentModal 
                open={modalOpen}
                setOpen={setModalOpen}
                handleBack={handleBack}
                handleVerify={handleVerify}
            />
        </>
    )
}